import { INCREMENT_PAGE_COUNT_ACTION } from './PageCountConstants';

export const incrementPageCount = () => ({
    type: INCREMENT_PAGE_COUNT_ACTION
});
